import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/api";
import { MediaUpload } from "../../components/admin/MediaUpload";

const MediaCard = ({ item, onChange }) => {
  const save = async (url) => {
    try { await api.put("/admin/site-media", { key: item.key, url }); onChange(item.key, url); toast.success("Imagem do site atualizada"); }
    catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); }
  };
  return (
    <div className="bg-white border border-[#9B6179]/5 rounded-[2px] overflow-hidden" data-testid={`site-media-${item.key}`}>
      <div className="aspect-[4/3] bg-[#F7F0E8]"><img src={item.url} alt={item.label} className="w-full h-full object-contain" data-testid={`site-media-preview-${item.key}`} /></div>
      <div className="p-3 space-y-2">
        <p className="text-sm text-[#6F3F55]">{item.label}</p>
        <MediaUpload folder="site" onUploaded={save} testid={`site-media-upload-${item.key}`} label="Substituir imagem" />
      </div>
    </div>
  );
};

export default function SiteMedia() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/admin/site-media").then((r) => setItems(r.data)).catch(() => {}); }, []);
  const onChange = (key, url) => setItems(items.map((i) => (i.key === key ? { ...i, url } : i)));

  return (
    <div data-testid="admin-site-media-page">
      <h1 className="text-2xl font-serif text-[#9B6179] mb-2">Mídia do site</h1>
      <p className="text-sm text-[#8A7980] mb-6">Imagens fixas do site, hospedadas no Bunny CDN. A troca é imediata no site público.</p>
      <div className="grid grid-cols-2 lg:grid-cols-3 gap-4">{items.map((i) => <MediaCard key={i.key} item={i} onChange={onChange} />)}</div>
    </div>
  );
}
